import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/CarouselNews/CarouselNews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/ListNews/ListNews.tsx");
